import type { VehicleAvailabilityWithSupplier } from "@apac/components/cars";
import type { TravelerInformationContext } from "@apac/components/checkout";
import type { ShopResponse } from "@b2bportal/ground-api";
import type {
  CartContext,
  CommonParentContext,
  ContactInformationContext,
  CardPaymentContext,
} from "@checkout/states";
import type { ParentState } from "@checkout/types";
import type { State } from "xstate";

type GroundSearchProperties = {
  properties: {
    market: string;
    airport: boolean;
    pick_up_date: string;
    pick_up_hour: string;
    drop_off_date: string;
    drop_off_hour: string;
    search_age: number;
    same_pickUp_dropOff: boolean;
    cars_advance: number;
    number_of_results: number;
    cheapest_price: number;
    cheapest_provider: string;
    pick_up_place_country: string;
    pick_up_place_city: string;
    pick_up_place_id: string;
    drop_off_place_city: string;
    drop_off_place_country: string;
    drop_off_place_id: string;
  };
};

export interface GroundShopContext {
  selectedVehicle: VehicleAvailabilityWithSupplier;
  shop: ShopResponse;
  trackingProperties?: GroundSearchProperties;
}

export const groundShopKey = "groundShop";

export interface GroundContext<AppFeatureFlags = object>
  extends CartContext,
    CommonParentContext<AppFeatureFlags> {
  [groundShopKey]: GroundShopContext;
  [ParentState.contactInformation]: ContactInformationContext;
  [ParentState.travelerInformation]: TravelerInformationContext;
  [ParentState.cardPayment]: CardPaymentContext;
}

export type GroundStateType = State<GroundContext>;
export type GroundStateWithoutValue = Pick<GroundStateType, "context">;

export type GroundShopStateType = State<{
  [groundShopKey]: GroundShopContext;
}>;

export type GroundShopStateWithoutValue = Pick<GroundShopStateType, "context">;
